import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { ConstellationField, Sparkle } from "@/components/shared/Motifs";
import { CtaButton } from "@/components/shared/CtaButton";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

export function FinalCTA() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].finalCta;

  return (
    <section className="relative overflow-hidden bg-navy py-20 sm:py-28" data-testid="final-cta">
      <ConstellationField className="pointer-events-none absolute inset-0 h-full w-full text-gold/[0.08]" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <Sparkle size={28} className="mx-auto text-gold" />
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-6 font-heading text-4xl font-semibold leading-[1.1] text-cream sm:text-5xl lg:text-6xl">
            {t.titleLines[0]}<br />
            {t.titleLines[1]}<br />
            <span className="text-gold">{t.titleLines[2]}</span>
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-cream/70">{t.sub}</p>
        </Reveal>
        <Reveal delay={240}>
          <div className="mt-9 flex justify-center">
            <CtaButton variant="gold" testId="final-cta-button" className="px-9 py-4 text-base">
              <MessageCircle className="h-5 w-5" />
              {t.cta}
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
